import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';
import OmsMonthlySummary from 'donor-elf-web/lib/custom-reports/oms-monthly-summary';
import moment from 'moment';

export interface CustomReportOmsMonthlySummaryRouteModel {
  records: OmsMonthlySummary[];
}

export default class CustomReportOmsMonthlySummaryRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'OMS Monthly Summary';
  }

  async model(): Promise<CustomReportOmsMonthlySummaryRouteModel> {
    let startDate = moment()
      .subtract(13, 'month')
      .startOf('month')
      .format('YYYY-MM-DD');
    let records = (
      await this.store.query('fund-custom-record', {
        filter: {
          record_type: 'oms_monthly_summary',
          oms_monthly_summary_start_date_after: startDate,
        },
      })
    ).slice();
    return {
      records: records.map((x) => new OmsMonthlySummary(x)),
    };
  }
}
